import { render, staticRenderFns } from "./newGraduSurvey.vue?vue&type=template&id=b6201e62&scoped=true"
import script from "./newGraduSurvey.vue?vue&type=script&lang=js"
export * from "./newGraduSurvey.vue?vue&type=script&lang=js"
import style0 from "./newGraduSurvey.vue?vue&type=style&index=0&id=b6201e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6201e62",
  null
  
)

export default component.exports